// Libraries
import { Button, Stack } from "@mui/material";

type TLoadLotsButtonProps = {
	disabled: boolean;
	refresh: () => void;
};

export default function LoadLotsButton(props: Readonly<TLoadLotsButtonProps>) {
	const { disabled, refresh } = props;

	return (
		<Stack direction={"row"} className="!mt-3">
			<Button
				onClick={() => refresh()}
				disabled={disabled}
				classes={{
					root: `!bg-[#2357BE] !font-sans !font-normal !text-sm !rounded-[6px] !capitalize !h-[30px] !shadow-none !text-white !w-[82px]`,
					disabled: "!bg-[#CCCCCC] !text-white",
				}}
			>
				Load Lots
			</Button>
		</Stack>
	);
}
